module.exports = __webpack_public_path__ + "img/7a2db3a.png";